import { compareUnorderedArrays } from '../../../utils/arrayUtils';
import { NO_UPDATE_ERROR } from '../../../utils/formValidation/commonErrorConstants';
import { getMultiSelectMessage } from '../../../utils/formValidation/errorMessageFunctions';
import { deepEqual } from '../../../utils/objectUtils';

export const validate = (selectedGenders, preSelectedGenderIds, newEntry, initialEntryState) => {
    let newErrors = {};
    let isGendersChanged = false;
    let isConstantsChanged = false;

    if (selectedGenders.length < 1) {
        newErrors = {
            ...newErrors,
            genderDetails: { error: true, message: getMultiSelectMessage('gender') }
        };
    }

    if (Object.keys(newErrors).length < 1) {
        isGendersChanged = !compareUnorderedArrays(preSelectedGenderIds, selectedGenders);
        isConstantsChanged = !deepEqual(newEntry, initialEntryState);
        if (!isGendersChanged && !isConstantsChanged) {
            newErrors = { button: { error: true, message: NO_UPDATE_ERROR } };
        }
    }

    return { newErrors, isGendersChanged, isConstantsChanged };
};
